import { Toaster as Sonner, toast as sonnerToast } from 'sonner';

// ToastProvider renders the Sonner toaster
export function ToastProvider() {
  return (
    <Sonner
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        duration: 4000,
      }}
    />
  );
}

// Toast API wrapper
interface ToastOptions {
  duration?: number;
  id?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const toast = {
  success: (message: string, options?: ToastOptions) =>
    sonnerToast.success(message, {
      duration: options?.duration,
      id: options?.id,
      action: options?.action,
    }),

  error: (message: string, options?: ToastOptions) =>
    sonnerToast.error(message, {
      duration: options?.duration,
      id: options?.id,
      action: options?.action,
    }),

  warning: (message: string, options?: ToastOptions) =>
    sonnerToast.warning(message, {
      duration: options?.duration,
      id: options?.id,
      action: options?.action,
    }),

  info: (message: string, options?: ToastOptions) =>
    sonnerToast.info(message, {
      duration: options?.duration,
      id: options?.id,
      action: options?.action,
    }),

  dismiss: (id?: string) => {
    if (id) {
      sonnerToast.dismiss(id);
    } else {
      sonnerToast.dismiss();
    }
  },

  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((err: Error) => string);
    }
  ) =>
    sonnerToast.promise(promise, {
      loading: messages.loading,
      success: messages.success,
      error: messages.error,
    }),
};
